import { useState } from "react";
import { toast } from "sonner";
import { Check, Pencil } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export const LogoNameEditor = ({ jobId, name, onSaved, className = "" }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(name);

  const save = async () => {
    const v = value.trim();
    if (!v || v === name) {
      setEditing(false);
      setValue(name);
      return;
    }
    try {
      const { data } = await api.patch(`/jobs/${jobId}`, { name: v });
      onSaved?.(data.name);
      toast.success("Logo renamed");
      setEditing(false);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Rename failed");
    }
  };

  if (!editing) {
    return (
      <button
        type="button"
        onClick={() => { setValue(name); setEditing(true); }}
        data-testid={`logo-name-${jobId}`}
        className={`group inline-flex items-center gap-2 text-left hover:text-[#ED5A24] transition-colors duration-200 ${className}`}
        title="Rename logo"
      >
        <span className="truncate">{name}</span>
        <Pencil className="w-3.5 h-3.5 opacity-40 group-hover:opacity-100 shrink-0" />
      </button>
    );
  }
  return (
    <form onSubmit={(e) => { e.preventDefault(); save(); }} className="inline-flex items-center gap-1">
      <input
        autoFocus
        maxLength={60}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={save}
        data-testid={`logo-name-input-${jobId}`}
        className={`border-b-2 border-[#ED5A24] bg-transparent outline-none min-w-0 ${className}`}
      />
      <button type="submit" className="text-[#ED5A24]" data-testid={`logo-name-save-${jobId}`} aria-label="Save name">
        <Check className="w-4 h-4" />
      </button>
    </form>
  );
};
